<div fxLayout="row wrap" fxLayout.xs="column" fxLayoutAlign="start end" fxFlex.gt-sm="100">
    <div class="widget" id="doctor-filter"  fxFlex.gt-sm="100">
        <mat-form-field class="mr-20 example-full-width date">
            <mat-label>Fecha</mat-label>
            <input class="w-100" matInput [matDatepicker]="fromPicker" [formControl]="FormElement" autocomplete="off">
            <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
            <mat-datepicker #fromPicker></mat-datepicker>
        </mat-form-field>
        <mat-error *ngIf="FormElement.invalid && FormElement.touched" class="error-space">
            <span>El formato de fecha no es válido (DD/MM/YYYY)</span>
        </mat-error>
    </div>
</div>